import React from 'react';

export const handleUnauthorizedAccess = () => {
  return<> <div className="wrapper"><div style={{ display: "flex", justifyContent: "center", flexDirection: "column"}}>
  <p>Musisz być zalogowany i mieć autoryzację</p>
  <br/>
  <a href="/pricing"><button>
  Powrót
</button></a>
</div></div>  <br/>
     <div className="wrapper">
     <p style={{ fontSize: "12px", marginBottom: "4px" }} >Cześć! Jeżeli widzisz ten komunikat to znaczy że Twoja subskrypcja się zakończyła.</p>
     <p style={{ fontSize: "12px", marginBottom: "4px" }} >Serdecznie zachęcamy do odnowienia subskrypcji <a href="/pricing" style={{ color: "white"}}>tutaj</a>.</p>
     <p style={{ fontSize: "12px" }}>Uwaga! Jeżeli uważasz że to błąd, skontaktuj się z nami <a href="/kontakt" style={{ color: "white"}}>tutaj</a>, lub skorzystaj z livechat, w prawym dolnym rogu.</p>
     </div></>;
};